import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, take, tap } from 'rxjs/operators';

import { QuickQuoteFeatureFacade } from '@amfam/policy/replace-vehicle/feature';
import { VehicleFeatures, VehicleQuoteService } from '@amfam/policy/shared';
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { CopyService } from '@amfam/shared/utility/shared-services';
import { DockingBarService, DsModalService, LoadingSpinnerService } from '@amfam/ui-kit';

import {
  AnalyticsEventType,
  ReplaceVehiclePaymentsFrequency,
  ReplaceVehicleQuickQuoteOperation
} from '../+state/quick-quote-feature/quick-quote-enum';

@Component({
  selector: 'future-payments-schedule',
  templateUrl: './future-payments-schedule.component.html',
  styleUrls: ['./future-payments-schedule.component.scss'],
  standalone: false
})
export class FuturePaymentsScheduleComponent implements OnDestroy, AfterViewInit {
  public exitFlowModalId = this.modalService.createModalId('exitFlowModalId');
  public exitFlowConfimationText = this.copyService.getCopy(
    'policy.replaceVehicleExitFlowConfimationText'
  );

  isPartner$ = this.store.select(BrandSelectors.selectIsPartner);
  futurePayments$ = this.quickQuoteFeatureFacade.futurePayments$.pipe(
    map(payments => this.vehicleQuoteService.mapPayments(payments))
  );
  vehicleFeatures = VehicleFeatures;

  paymentFrequency = '';

  constructor(
    private quickQuoteFeatureFacade: QuickQuoteFeatureFacade,
    private store: Store,
    private vehicleQuoteService: VehicleQuoteService,
    private spinnerService: LoadingSpinnerService,
    private modalService: DsModalService,
    private copyService: CopyService,
    private dockingBarService: DockingBarService
  ) {
    this.dockingBarService.registerHeading('Replace Vehicle');
  }

  ngAfterViewInit(): void {
    this.futurePayments$
      .pipe(
        take(1),
        tap(p => {
          this.paymentFrequency =
            p?.length > 1
              ? ReplaceVehiclePaymentsFrequency.MONTHLY_PAY
              : ReplaceVehiclePaymentsFrequency.FULL_PAY;
          this.quickQuoteFeatureFacade.sendAnalytics(
            AnalyticsEventType.REPLACE_VEHICLE_FUTURE_PAYMENTS,
            '',
            '',
            this.paymentFrequency
          );
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.spinnerService.stop();
  }

  cancel() {
    this.modalService.open(this.exitFlowModalId);
    this.quickQuoteFeatureFacade.sendAnalytics(
      AnalyticsEventType.REPLACE_VEHICLE_FUTURE_PAYMENTS_CANCEL,
      '',
      '',
      this.paymentFrequency
    );
  }

  goBack() {
    this.store.dispatch(fromRouterActions.Back());
  }

  replaceVehicle() {
    this.spinnerService.start({ blockActions: true });
    this.quickQuoteFeatureFacade.setOperation(
      ReplaceVehicleQuickQuoteOperation.REPLACE_VEHICLE_BIND
    );
    this.quickQuoteFeatureFacade.bindQuoteOnline();
  }

  stay() {
    this.modalService.close(this.exitFlowModalId);
  }

  leave() {
    this.store.dispatch(fromRouterActions.Go({ path: ['overview'] }));
  }

  sendToAgent(isCancelEvent = false) {
    this.spinnerService.start({ blockActions: true });
    this.quickQuoteFeatureFacade.setOperation(
      ReplaceVehicleQuickQuoteOperation.REPLACE_VEHICLE_COMPARE_QUOTE_SEND_TO_AGENT
    );
    const analyticsType = isCancelEvent
      ? AnalyticsEventType.REPLACE_VEHICLE_FUTURE_PAYMENTS_CANCEL_SEND_TO_AGENT
      : AnalyticsEventType.REPLACE_VEHICLE_FUTURE_PAYMENTS_SEND_TO_AGENT;

    this.quickQuoteFeatureFacade.sendAnalytics(analyticsType, '', '', this.paymentFrequency);
    this.quickQuoteFeatureFacade.sendToAgentOnCancel(isCancelEvent);
  }
}
